import Router from 'next/router';
import { OUTSIDE_INC_URLS, OUTSIDE_ONLINE_URLS, SITE_NAME } from 'lib/constants';
import {
  getProfileURL,
  getSettingsURL,
  getSubscriptionURL
} from 'utils/accountsUrls';
import { routes } from 'lib/routes';
import { noop } from 'utils/noop';

import type { NavigationConfig } from './types';

export const getNavigationConfig = (): NavigationConfig => ({
  onNavigate: (event) => {
    switch (event.detail.destination) {
      case 'benefits':
        return Router.push(routes.myBenefits());
      case 'bookmarks':
        return Router.push(routes.bookmarks());
      case 'help':
        return Router.push(OUTSIDE_INC_URLS.HELP);
      case 'oplus':
        return Router.push(OUTSIDE_ONLINE_URLS.MARKETING_LANDING_PAGE);
      case 'profile':
        return Router.push(getProfileURL());
      case 'register':
        return Router.push(OUTSIDE_ONLINE_URLS.MARKETING_LANDING_PAGE);
      case 'settings':
        return Router.push(getSettingsURL());
      case 'sign-in':
        return Router.push(getSignInURL(SITE_NAME));
      case 'sign-out':
        return Router.push(getSignOutURL());
      case 'subscription':
        return Router.push(getSubscriptionURL());
      default:
        return noop;
    }
  },
  // Profile switching is not fully implemented yet, however we will leave it for future implementation
  onProfileSwitch: noop
});

const getSignInURL = (analyticsDomain: string) => {
  const location =
    window.location.origin + window.location.pathname + window.location.search;

  const redirectURL = new URL('/login', window.location.origin);

  redirectURL.searchParams.set('origin_uri', location);
  redirectURL.searchParams.set('analytics_domain', analyticsDomain);
  // SearchParams setter encodes input. Decode for auth-hub login middleware
  redirectURL.search = decodeURIComponent(redirectURL.search);

  return redirectURL;
};

/**
 * Derived from https://github.com/pocketoutdoormedia/outside-auth-header/blob/a3bf96e82692f4efa7d7625894360886c02ea7fb/utils/auth/index.ts#L161
 */
const getSignOutURL = () => {
  const signOutURL = new URL('/logout', window.location.origin);
  const originURI = window.location.origin + window.location.pathname;

  signOutURL.searchParams.set('origin_uri', originURI);
  // auth hub expects origin_uri to not be encoded
  signOutURL.search = decodeURIComponent(signOutURL.search);

  return signOutURL;
};
